import React from "react"
import { Form, FormGroup, Label, Container, Row, Col, Input } from "reactstrap"
import stellarProcessing from "../../../view/assets/stellar-animation.gif"
import cow from "../../../view/assets/cow.png"
import { Trans, useLingui } from "@lingui/react"
import PropTypes from "prop-types"
import { toast } from "react-toastify"
import { WarningMessage } from "../../../view/shared/notifications/Notifications"
import { connect } from "react-redux"
import validateInput from "../../../view/shared/validations/buyShares"
import LastSharesBought from "../../reverseTransactions/LastSharesBought"
import { currentTransactionContext } from "../../../store/actions/transactionContext"
import { getCurrency } from "../../../view/shared/utilities/currency"
import { initiateTransaction } from "../../../store/reducers/transactions/actions"
import { selectCreatedVslaInfo } from "../../../store/reducers/getVslas"
import { setCurrentPage } from "../../../store/reducers/navigation"
import { arabicToInt } from "../../../view/shared/utilities/arabicNumParser"
import styles from "./style.module.css"

const notify = (msg) => toast(msg)

const BuyShares = (props) => {
  const { i18n } = useLingui()

  React.useEffect(() => {
    props.pushTransactionContext("Shares bought")
  }, [])

  const [share_value, setShareValue] = React.useState(props.group?.cycle?.shareValue)
  React.useEffect(() => {
    if (!props.vsla) {
      return
    }
    setShareValue(props.group?.cycle?.shareValue)
  }, [props.vsla])

  const [state, setState] = React.useState({
    amount: "",
    omt_receipt_number: "",
    asset: "SC",
    source: "issuer",
    dest: "member",
    loading: false,
    errors: {},
  })

  const onChange = (e) => setState({ ...state, [e.target.name]: e.target.value })

  const isValid = () => {
    const { errors, isValid } = validateInput(state)

    if (!isValid) {
      setState({ ...state, errors })
    }

    return isValid
  }

  const onSubmit = (e) => {
    e.preventDefault()
    if (isValid()) {
      processTransaction(
        arabicToInt(state.amount),
        state.asset,
        state.source,
        state.dest,
        state.omt_receipt_number,
      )
      setState({ ...state, amount: "", omt_recipt_number: "" })
    }
  }

  const redirectBack = () => {
    props.setPage("group-memberActions")
  }

  const processTransaction = (amount, asset, source, dest, omt_receipt_number) => {
    const lang_code = i18n.locale

    const lang = {
      fr: {
        message: `Confirmer ajouter ${state.amount} versements pour le membre`,
      },
      en: {
        message: `Confirm buy ${state.amount} shares for member`,
      },
      sw: {
        message: `Thibitisha ununuzi wa hisa ${state.amount} kwa mwanachama`,
      },
      ZARMA: {
        message: `Zarma for Confirm buy ${state.amount} shares for member`,
      },
      HAOUSSA: {
        message: `Tabbatar da ỳar rukuni ta shiga adashe hannu ${state.amount}`,
      },
      es: {
        message: `Confirmar comprar ${state.amount} acciones para miembro`,
      },
      lb: {
        message: `Confirm adding ${state.amount} of savings for household`,
      },
      pt: {
        message: `Confirme a compra de ${state.amount} ações para o membro`,
      },
      ar: {
        message: `أكد إضافة ${state.amount} إلى مدخرات الأسرة`,
      },
    }

    if (window.confirm(lang[lang_code].message)) {
      const franc = parseFloat(parseFloat(amount) * parseFloat(share_value)).toFixed(
        2,
      )
      if (amount !== "") {
        buyShares(franc.toString(), omt_receipt_number)
      }
    } else {
      notify(<WarningMessage />)
    }
  }

  const buyShares = (amount, omt_receipt_number) => {
    const uuid = props.currentMember.pubkey
    props.commitTransaction({
      uid: uuid,
      type: "BUY_SHARES",
      sharePrice: 1,
      amount: parseFloat(amount),
      metadata: {
        omtReceiptNumber: omt_receipt_number,
      },
      ...(props.currentMember?.id
        ? {
          member_id: props.currentMember?.id,
        }
        : {
          memberCacheId:
            props.currentMember?.cacheId || props.currentMember?.pubkey,
        }),
    })
    notify(<WarningMessage msg={"Processing Transaction"} />)
    redirectBack()
  }

  if (!state.loading) {
    return (
      <Container>
        <div>
          <h4 className={styles.header}>{props.currentMember?.full_name}</h4>
        </div>
        <div>
          <h4 className={styles.header}>
            <Trans id="buy.shares">Buy Shares</Trans>
          </h4>
        </div>

        <Row>
          <br />
          <Col>
            <Form onSubmit={onSubmit}>
              <Container>
                {props.group?.country !== "Lebanon" &&
                  i18n.locale !== "ARABIC" && (
                    <FormGroup>
                      <Row>
                        <Col xs="3" sm="4">
                          <img
                            src={cow}
                            className={styles.cowImage}
                            alt="CARE VSLA"
                          />
                        </Col>
                        <Col xs="7" sm="4"></Col>
                        <Col xs="2" sm="4">
                          <Input
                            name="amount"
                            type="radio"
                            id="cow1"
                            className={styles.formInput}
                            onChange={onChange}
                            value="1"
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col xs="6" sm="4">
                          <img
                            src={cow}
                            className={styles.cowImage}
                            alt="CARE VSLA"
                          />
                          <img
                            src={cow}
                            className={styles.cowImage}
                            alt="CARE VSLA"
                          />
                        </Col>
                        <Col xs="4" sm="4"></Col>
                        <Col xs="2" sm="4">
                          <Input
                            name="amount"
                            type="radio"
                            id="cow2"
                            className={styles.formInput}
                            onChange={onChange}
                            value="2"
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col xs="6" sm="4">
                          <img
                            src={cow}
                            className={styles.cowImage}
                            alt="CARE VSLA"
                          />
                          <img
                            src={cow}
                            className={styles.cowImage}
                            alt="CARE VSLA"
                          />
                          <img
                            src={cow}
                            className={styles.cowImage}
                            alt="CARE VSLA"
                          />
                        </Col>
                        <Col xs="4" sm="4"></Col>
                        <Col xs="2" sm="4">
                          <Input
                            name="amount"
                            type="radio"
                            id="cow3"
                            className={styles.formInput}
                            onChange={onChange}
                            value="3"
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col xs="10" sm="8">
                          <img
                            src={cow}
                            className={styles.cowImage}
                            alt="CARE VSLA"
                          />
                          <img
                            src={cow}
                            className={styles.cowImage}
                            alt="CARE VSLA"
                          />
                          <img
                            src={cow}
                            className={styles.cowImage}
                            alt="CARE VSLA"
                          />
                          <img
                            src={cow}
                            className={styles.cowImage}
                            alt="CARE VSLA"
                          />
                        </Col>

                        <Col xs="2" sm="4">
                          <Input
                            name="amount"
                            type="radio"
                            id="cow4"
                            className={styles.formInput}
                            onChange={onChange}
                            value="4"
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col xs="10" sm="8">
                          <img
                            src={cow}
                            className={styles.cowImage}
                            alt="CARE VSLA"
                          />
                          <img
                            src={cow}
                            className={styles.cowImage}
                            alt="CARE VSLA"
                          />
                          <img
                            src={cow}
                            className={styles.cowImage}
                            alt="CARE VSLA"
                          />
                          <img
                            src={cow}
                            className={styles.cowImage}
                            alt="CARE VSLA"
                          />
                          <img
                            src={cow}
                            className={styles.cowImage}
                            alt="CARE VSLA"
                          />
                        </Col>
                        <Col xs="2" sm="4">
                          <Input
                            name="amount"
                            type="radio"
                            id="cow5"
                            className={styles.formInput}
                            onChange={onChange}
                            value="5"
                          />
                        </Col>
                      </Row>
                    </FormGroup>
                  )}

                <FormGroup>
                  {["ar", "lb"].includes(i18n.locale) && (
                    <Label className={styles.formLabel}>
                      {i18n._("Savings Amount")}
                    </Label>
                  )}
                  <span className={styles.errorMessage}>{state.errors.amount}</span>
                  <Input
                    type="number"
                    name="amount"
                    className={styles.formInput}
                    placeholder={i18n._("Number of shares")}
                    onChange={onChange}
                    value={state.amount}
                  />
                </FormGroup>
                {["ar", "lb"].includes(i18n.locale) && (
                  <FormGroup>
                    <Label className={styles.formLabel}>
                      {i18n._("OMT Receipt Number")}
                    </Label>
                    <span className={styles.errorMessage}>
                      {state.errors.omt_receipt_number}
                    </span>
                    <Input
                      type="text"
                      name="omt_receipt_number"
                      className={styles.formInput}
                      placeholder={i18n._("Enter Receipt Number")}
                      onChange={onChange}
                      value={state.omt_receipt_number}
                    />
                  </FormGroup>
                )}
                {!["ar", "lb"].includes(i18n.locale) && (
                  <div className={styles.info}>
                    {share_value !== 0 ? (
                      <p>
                        <i>
                          1 {i18n._("Share")} = {parseFloat(share_value).toFixed(2)}{" "}
                          {!["ar", "lb"].includes(i18n.locale) &&
                            getCurrency(props.group?.country).symbol}
                          {["ar", "lb"].includes(i18n.locale) &&
                            (props.vsla?.metadata?.currency === "USD"
                              ? getCurrency(props.group?.country).usd_symbol
                              : getCurrency(props.group?.country).lbp_symbol)}
                        </i>
                      </p>
                    ) : (
                      <span>
                        <Trans id="loading.share.value">
                          Loading share value...
                        </Trans>
                      </span>
                    )}
                    {state.amount && (
                      <p>
                        <b>
                          {i18n._("Total Amount")} ={" "}
                          {parseFloat(
                            parseFloat(state.amount) * parseFloat(share_value),
                          ).toFixed(2)}{" "}
                          {!["ar", "lb"].includes(i18n.locale) &&
                            getCurrency(props.group?.country).symbol}
                          {["ar", "lb"].includes(i18n.locale) &&
                            (props.vsla?.metadata?.currency === "USD"
                              ? getCurrency(props.group?.country).usd_symbol
                              : getCurrency(props.group?.country).lbp_symbol)}
                        </b>
                      </p>
                    )}
                  </div>
                )}
              </Container>
              <Container>
                <FormGroup>
                  <Input
                    type="submit"
                    value={i18n._("Submit")}
                    name="submit"
                    className={`btn btn-primary ${styles.submitButton}`}
                  />
                </FormGroup>
              </Container>
            </Form>
          </Col>
        </Row>
        {props.isConnected && (
          <LastSharesBought
            redirectBack={redirectBack.bind(this)}
            reversal_details={{
              destFundType: "issuer",
              reversalTransactionType: "Shares bought reversed",
            }}
            transactions={props.transactions}
          />
        )}
      </Container>
    )
  }

  return (
    <div className={styles.spinnerContainer}>
      <img src={stellarProcessing} className={styles.spinner} alt="Stellar" />
    </div>
  )
}

BuyShares.propTypes = {
  vsla: PropTypes.object,
  pushTransactionContext: PropTypes.func,
  setPage: PropTypes.func,
  currentMember: PropTypes.object,
  commitTransaction: PropTypes.func,
  ongoingMeeting: PropTypes.object,
  group: PropTypes.object,
  isConnected: PropTypes.bool,
  transactions: PropTypes.array,
}

const mapStateToProps = (state) => {
  const { accountV2, loadedMember } = state
  const selectMemberReversableTransactions = (type) => {
    const memberPubkey = loadedMember?.pubkey
    if (!memberPubkey) {
      return []
    }
    else if (!accountV2.online?.transactions) {
      return []
    }
    return accountV2.online?.transactions?.[memberPubkey]?.filter(tx => tx.type === type) || []
  }
  return {
    user: state.user,
    vsla: state.vsla,
    error: state.error,
    isConnected: state.isConnected,
    ongoingMeeting: state.meeting?.ongoing,
    currentMember: state.loadedMember,
    group: state.group,
    vslaSummary: selectCreatedVslaInfo(state),
    numberOfMeetings: state.groupMeetings,
    transactions: selectMemberReversableTransactions('BUY_SHARES'),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setPage: (page) => dispatch(setCurrentPage(page)),
    commitTransaction: (data) => dispatch(initiateTransaction(data)),
    pushTransactionContext: (type) => dispatch(currentTransactionContext(type)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(BuyShares)
